import { all } from 'redux-saga/effects';
import signInSaga from '../modules/Authentication/sagas/signInSaga';
import devSignInSaga from '../modules/Authentication/sagas/devSignInSaga';
import verifyTokenSaga from '../modules/Authentication/sagas/verifyTokenSaga';
import workOrders from '../modules/WorkorderList/sagas/workOrderList';
import productList from '../modules/WorkorderList/sagas/productList';
import mapIdSaga from '../modules/Map/sagas/mapIdSaga';
import mapTokenSaga from '../modules/Map/sagas/mapTokenSaga';
import getHealthCheckSaga from '../modules/HealthCheck/sagas/getHealthCheck';
import updateHealthCheckSaga from '../modules/HealthCheck/sagas/updateHealthCheck';
import removeServiceSaga from '../modules/WorkLog/sagas/services/removeServiceSaga';
import updateServiceSaga from '../modules/WorkLog/sagas/services/updateServiceSaga';
import findServicesSaga from '../modules/WorkLog/sagas/services/findServicesSaga';
import zendeskSaga from '../modules/WorkLog/sagas/complete/zendeskSaga';
import completeStatusSaga from '../modules/WorkLog/sagas/complete/completeStatusSaga';
import devicePollingMacSaga from '../modules/HealthCheck/sagas/devicePollingMacSaga';
import devicePollingCustomer from '../modules/HealthCheck/sagas/getDevicePollingCustomer';
import iccCheckSaga from '../modules/HealthCheck/sagas/getIccCheck';
import updateDevicePollingMacSaga from '../modules/HealthCheck/sagas/updateDevicePollingMacSaga';
import startDaySaga from '../modules/Authentication/sagas/startDaySaga';
import endDaySaga from '../modules/Authentication/sagas/endDaySaga';
import findServiceTypesSaga from '../modules/CreateNewWorkOrder/sagas/findServiceTypesSaga';
import workorderServicesSaga from '../modules/WorkLog/sagas/services/workorderServices';
import followUpFormsSaga from '../modules/FollowUpForms/sagas/followUpFormsSaga';
export default function* rootSaga() {
    yield all([
        ...signInSaga,
        ...devSignInSaga,
        ...verifyTokenSaga,
        ...workOrders,
        ...mapIdSaga,
        ...mapTokenSaga,
        ...productList,
        ...getHealthCheckSaga,
        ...updateHealthCheckSaga,
        ...removeServiceSaga,
        ...updateServiceSaga,
        ...findServicesSaga,
        ...zendeskSaga,
        ...completeStatusSaga,
        ...devicePollingMacSaga,
        ...iccCheckSaga,
        ...devicePollingCustomer,
        ...updateDevicePollingMacSaga,
        ...startDaySaga,
        ...endDaySaga,
        ...findServiceTypesSaga,
        ...workorderServicesSaga,
        ...followUpFormsSaga,
    ]);
}
